import { Checkbox, TableCell, TableHead, TableRow } from '@mui/material';
import React from 'react';

import { useShippingAndTrackingContext } from '../context/shippingAndTracking';

export const ShippingAndTrackingTableHeader: React.FC = () => {
    const { checkedRows, setCheckedRows, orders } = useShippingAndTrackingContext();

    const isIndeterminate = checkedRows.length && checkedRows.length < orders.length ? true : false;

    const fullyChecked = checkedRows.length && checkedRows.length === orders.length ? true : false;

    const handleCheckAll = () => {
        setCheckedRows(orders.map((elem) => elem.document.poDocId));
    };

    const handleUncheckAll = () => {
        setCheckedRows([]);
    };

    const handleCheckChanges = () => {
        if (isIndeterminate || !checkedRows.length) {
            handleCheckAll();
        } else {
            handleUncheckAll();
        }
    };

    return (
        <TableHead className="bg-white py-10 container sticky top-[64px] z-[4]">
            <TableRow className="parent-row ">
                <TableCell>
                    <Checkbox
                        color="primary"
                        indeterminate={isIndeterminate}
                        checked={fullyChecked}
                        onChange={handleCheckChanges}
                    />
                </TableCell>
                <TableCell>Season / Delivery</TableCell>
                <TableCell>Audit</TableCell>
                <TableCell>Style type</TableCell>
                <TableCell>Vendor</TableCell>
                <TableCell>WHS</TableCell>
                <TableCell>PO#</TableCell>
                <TableCell>PO Ref#</TableCell>
                <TableCell>Style#</TableCell>
                <TableCell>Color Desc</TableCell>
                <TableCell>Style Desc</TableCell>
                <TableCell>Original QTY</TableCell>
                <TableCell>Shipped QTY</TableCell>
                <TableCell>QTY Difference</TableCell>
                <TableCell>Audit Status</TableCell>
                <TableCell>Audit Result</TableCell>
                <TableCell>Packing List</TableCell>
                <TableCell>Invoice</TableCell>
                <TableCell>Hand Over Date to F.F</TableCell>
                <TableCell>AWB</TableCell>
                <TableCell>Planned ETD</TableCell>
                <TableCell>Planned in DC Date</TableCell>
                <TableCell>Planned ETA</TableCell>
                <TableCell>Received Date</TableCell>
                <TableCell>Received QTY</TableCell>
                <TableCell>Delivery Status</TableCell>
            </TableRow>
        </TableHead>
    );
};
